import { useDispatch } from 'react-redux';
// Use throughout your app instead of plain `useDispatch`
var useAppDispatch = useDispatch;
export default useAppDispatch;
